module.exports = __webpack_public_path__ + "img/species.1b5cd555.png";